<template>
    <label class="custom-upload">
        <slot></slot>
        <input
            ref="uploadInput"
            :name="name"
            accept="image/jpg, image/jpeg, image/png, image/svg+xml"
            class="d-none"
            type="file"
            @change="selectFile"
        />
        <a-modal v-if="isShowModal" v-model:open="isShowModal" :maskClosable="false" title="Crop Image" @ok="getResult">
            <VuePictureCropper
                :boxStyle="{
                    width: '100%',
                    height: '100%',
                    backgroundColor: '#f8f8f8',
                    margin: 'auto',
                }"
                :img="pic"
                :options="{
                    viewMode: 1,
                    dragMode: 'crop',
                    aspectRatio: aspectRatio,
                }"
            />
        </a-modal>
    </label>
</template>

<script>
import VuePictureCropper, {cropper} from 'vue-picture-cropper'
import {useToast} from "vue-toastification";

export default {
    components: {
        VuePictureCropper,
    },
    props: {
        modelValue: Blob | String, // v-model for the cropped image result
        name: {
            type: String,
            default: 'image',
        },
        aspectRatio: {
            type: Number,
            default: 1,
        },
        base64String: {
            type: String,
            default: '',
        },
        maxSize: {
            type: Number,
            default: null,
        }
    },
    data() {
        return {
            isShowModal: false,
            pic: '',
            toast: useToast(),
        };
    },
    methods: {
        selectFile(e) {
            // Reset last selection and results
            this.pic = ''

            // Get selected files
            const {files} = e.target
            if (!files || !files.length) return

            // Convert to dataURL and pass to the cropper component
            const file = files[0]
            const reader = new FileReader()
            reader.readAsDataURL(file)
            reader.onload = () => {
                // Update the picture source of the `img` prop
                this.pic = String(reader.result)

                // Show the modal
                this.isShowModal = true

                // Clear selected files of input element
                if (!this.$refs.uploadInput) return
                this.$refs.uploadInput.value = null
            }
        },

        /**
         * Get cropping results
         */
        async getResult() {
            if (!cropper) return
            const base64 = cropper.getDataURL()
            const blob = await cropper.getBlob()
            if (!blob) return
            // if (this.maxSize && blob.size > this.maxSize * 1024) {
            //     this.toast.error(`Image size must be less than ${this.maxSize / 1024 } MB`)
            //     return
            // }
            // Update the v-model
            this.isShowModal = false
            this.$emit('update:modelValue', blob)
            this.$emit('update:base64String', base64)
        },
    },
};
</script>
